export default {
  DATAMENUS(state) {
    return state.dataMenus
  },
  gettersEditMenus(state) {
    return state.editMenu
  },
}